import React, { Component } from "react";
import firebaseManager from "../../../../model/Firebase/FirebaseManager";
import { Redirect } from "react-router-dom";

class NewUserTechnicianAuth extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.signup = this.signup.bind(this);
    this.state = {
      email: "",
      password: "",
      firstName: "",
      lastname: "",
      address: "",
      phoneNumber: "",
      redirectToHome: false,
    };
  }

  signup(e) {
    e.preventDefault();
    if (this.state.phoneNumber === "") {
      document.getElementById("alert").classList.remove("d-none");
    } else {
      firebaseManager.createUserTechnician(
        this.state.email,
        this.state.password,
        this.state.firstName,
        this.state.lastname,
        this.state.address,
        this.state.phoneNumber,
        this.loginCallbackSuccess,
        this.loginCallbackFail
      );
    }
  }

  loginCallbackSuccess = () => {
    this.setState({
      redirectToHome: true,
    });
  };

  loginCallbackFail(errMessage) {
    alert(errMessage);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  render() {
    return (
      <React.Fragment>
        {this.state.redirectToHome ? (
          <Redirect push to="/homeTechnician" />
        ) : null}
        <div className="text-center mt-5">
          <form className="mx-auto mt-5">
            <div className="form-group">
              <p className="text-center mt-5">Name</p>
              <input
                type="text"
                id="firstName"
                name="firstName"
                onChange={this.handleChange}
                value={this.state.firstName}
                className=" size"
                placeholder="First"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                id="lastname"
                name="lastname"
                onChange={this.handleChange}
                value={this.state.lastname}
                className=" size"
                placeholder="Last"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                onChange={this.handleChange}
                value={this.state.phoneNumber}
                className=" size"
                placeholder="Phone Number"
                required
              />
            </div>
            <p className="text-center mt-4">Login Info</p>
            <div className="form-group">
              <input
                type="email"
                name="email"
                id="email"
                onChange={this.handleChange}
                value={this.state.email}
                className=" size"
                aria-describedby="emailHelp"
                placeholder="Email"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                id="password"
                name="password"
                onChange={this.handleChange}
                value={this.state.password}
                className=" size"
                placeholder="Password"
                required
              />
            </div>
            <div className="form-group">
              <p className="text-center mt-4">Address</p>
              <textarea
                onChange={this.handleChange}
                name="address"
                value={this.state.address}
                className="mx-auto"
                id="exampleFormControlTextarea1"
              ></textarea>
            </div>
            <button onClick={this.signup} className="btn btn-secondary">
              Signup
            </button>
          </form>
        </div>
      </React.Fragment>
    );
  }

  // constructor()
  // {
  //     super();
  //     this.handleChange = this.handleChange.bind(this);
  //     this.signup = this.signup.bind(this);
  //     this.state={
  //         firstName : "",
  //         lastName : "",
  //         email: "",
  //         password: "",
  //         address: "",
  //     }
  // }

  // signup(e){
  //     e.preventDefault();
  //     firebaseManager.createUserTechnician(this.state.firstName, this.state.lastName, this.state.email, this.state.password, this.state.address, this.loginCallbackFail, this.loginCallbackSuccess)
  // }

  // handleChange(e){
  //     this.setState({
  //         [e.target.name] : e.target.value
  //     })
  // }
  // loginCallbackSuccess = () => {
  //     // this.setState({
  //     //     redirectToHome: true
  //     // })
  //     console.log("inicio")
  // }

  // loginCallbackFail(errMessage) {
  //     alert(errMessage);
  // }
  // render()
  // {
  //     return(
  //         <div>
  //              { this.state.redirectToHome ? (<Redirect push to="/homeTechnician"/>) : null }
  //             <div className="text-center">
  //             <div className="form-group">
  //                 <p className="text-center mt-5">Name</p>
  //                 <input type="text" id="firstName" name="firstName" onChange={this.handleChange} value={this.state.firstName} className=" size" placeholder="First" required />
  //             </div>
  //             <div className="form-group">
  //                 <input type="lastName" id="lastname" name="lastName" onChange={this.handleChange} value={this.state.lastName} className=" size" placeholder="Last" required />
  //             </div>
  //             <div className="form-group">
  //                 <p className="text-center mt-4">Login Info</p>
  //                 <input type="email" id="email" name="email" onChange={this.handleChange} value={this.state.email} className=" size" placeholder="Email" required />
  //             </div>
  //             <div className="form-group">
  //                 <input type="password" id="password" name="password" onChange={this.handleChange} value={this.state.password} className=" size" placeholder="Password" required />
  //             </div>
  //             <div className="form-group">
  //                 <p className="text-center mt-4">Address</p>
  //                 <textarea onChange={this.handleChange} name="address"  value={this.state.address} className="form-control sizeTextArea mx-auto" id="exampleFormControlTextarea1"></textarea>
  //             </div>
  //             <button onClick={this.signup} className="btn btn-secondary mx-auto">Get started</button>
  //             </div>
  //         </div>
  //     )
  // }
}
export default NewUserTechnicianAuth;
